import { CookieMessage } from '../../components/cookie-message/cookie-message';

class YoutubePlayer {
    constructor ($players) {
        this.$$players = $players;
        this.players = [];
        this.$playerContainer = null;
        this.youtubeLoaded = false;
        this.cookieId = 'C0004';
        this.youtubeAllowed = false;
        this.CookieMessageAPI = null;
    }

    init () {
        const loadYouTubeAfterConsent = () => {
            this.youtubeAllowed = window.enabledCookies.includes(this.cookieId);

            this.initalizeCookieMessage();
            this.setEvents();

            if (window.youTubeReady === null) {
                this.toggleApiState();
            }

            window.onYouTubeIframeAPIReady = () => {
                window.youTubeReady = true;
                const OnetrustInitalizedCallbacks = () => {
                    this.togglePlayer();

                    const handleConsentChange = () => {
                        this.togglePlayer();
                    };

                    window.addEventListener('cookieConsentChanged', handleConsentChange);
                };

                OnetrustInitalizedCallbacks();
            };
        };

        if (window.oneTrustInitialized) {
            loadYouTubeAfterConsent();
        } else {
            window.addEventListener('cookieConsentInitialized', loadYouTubeAfterConsent);
        }
    }

    toggleApiState () {
        if (this.youtubeAllowed && window.youTubeReady === null) {
            import('../../lib/youtube-api-loader').then(({ loadYoutubeApi }) => {
                loadYoutubeApi();
            });
        }
    }

    initalizeCookieMessage () {
        if (this.$$players.length > 0) {
            this.$$players.forEach($player => {
                const $cookieMessage = $player.parentNode.querySelector('[data-cookiemessage]');

                if ($cookieMessage) {
                    this.CookieMessageAPI = new CookieMessage($cookieMessage);
                    this.CookieMessageAPI.initialize();
                }
            });
        }
    }

    togglePlayer () {
        if (window.enabledCookies.includes('C0004')) {
            if (!this.youtubeLoaded) {
                if (this.isMobileDevice()) {
                    for (let i = 0; i < this.$$players.length; i++) {
                        const $player = this.$$players[i];
                        this.initVideo($player, 'mobile');
                    }
                } else {
                    this.bindEvents();
                }

                this.youtubeLoaded = true;
            }
        } else {
            if (this.youtubeLoaded) {
                this.deactivate();
                this.youtubeLoaded = false;
            }
        }
    }

    bindEvents () {
        for (let i = 0; i < this.$$players.length; i++) {
            const $player = this.$$players[i];

            $player.addEventListener('click', () => {
                this.initVideo($player, 'desktop');
            });
        }
    }

    initVideo ($player, deviceType) {
        this.$playerContainer = document.createElement('DIV');
        $player.parentNode.appendChild(this.$playerContainer);
        const id = $player.getAttribute('data-youtube');
        const isPlaylist = $player.getAttribute('data-youtube-playlist') !== null;
        let options = {};

        if (deviceType === 'desktop') {
            options = {
                videoId: id,
                autoplay: 1,
                events: {
                    onReady: () => {
                        console.log('video loaded');
                        player.playVideo();
                    },
                    onStateChange: (event) => {
                        if (event.data === 1 || event.data === 3) {
                            this.pauseOtherVideos(player, event);
                        } else if (event.data === 0) {
                            this.removeVideo($player.parentNode);
                        }
                    }
                }
            };
        } else if (deviceType === 'mobile') {
            options = {
                videoId: id,
                autoplay: 0,
                events: {
                    onReady: () => {
                        console.log('video loaded');
                    },
                    onStateChange: (event) => {
                        this.pauseOtherVideos(player, event);
                    }
                }
            };
        }

        if (isPlaylist) {
            options.playerVars = {
                listType: 'playlist',
                list: id
            };
        }

        const player = new YT.Player(this.$playerContainer, options); // eslint-disable-line no-undef
        this.players.push(player);
    }

    pauseOtherVideos (player, event) {
        for (let i = 0; i < this.players.length; i++) {
            const otherPlayer = this.players[i];
            if (event.data === YT.PlayerState.PLAYING || event.data === YT.PlayerState.BUFFERING) { // eslint-disable-line no-undef
                if (otherPlayer !== player) {
                    otherPlayer.pauseVideo();
                }
            }
        }
    }

    removeVideo ($wrapper) {
        const $iframe = $wrapper.querySelector('iframe');
        if ($iframe) {
            $iframe.classList.add('is--stopped');
            setTimeout(() => {
                $iframe.remove();
            }, 750);
        }
    }

    isMobileDevice () {
        const windowWidth = window.innerWidth;
        return windowWidth < window.OPTIONS.breakpoints.m && document.documentElement.classList.contains('no-csshover');
    }

    // Method to deactivate videos
    deactivate () {
        this.$$players.forEach(($player) => {
            this.removeVideo($player.parentNode);
        });

        this.players = []; // Clear the players array
    }

    setEvents () {
        const handleConsentChange = () => {
            this.youtubeAllowed = window.enabledCookies.includes(this.cookieId);
            this.toggleApiState();
        };

        window.addEventListener('cookieConsentChanged', handleConsentChange);
    }
}

export { YoutubePlayer };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$youtubeVideo = $context.querySelectorAll('[data-youtube]');
        for (let i = 0; i < $$youtubeVideo.length; i++) {
            const $youtube = new YoutubePlayer($$youtubeVideo, window.OPTIONS.breakpoints);
            $youtube.init();
        }
    }
});
